const APP_URL = import.meta.env.VITE_GLOBAL_APP_URL;

const CONTACT_US_LINK = 'https://givebutter.com/contact';
const CONTACT_SALES_LINK = 'https://givebutter.com/demo-plus';
const DOCS_LINK = 'https://docs.givebutter.com';
const HELP_CENTER_LINK = 'https://help.givebutter.com/en';
const WEBINARS_LINK = 'https://givebutter.com/events';
const BUTTER_BLOG_LINK = 'https://givebutter.com/blog';
const FREEBIES_LINK = 'https://givebutter.com/freebies';
const ROADMAP_LINK = 'https://community.givebutter.com/';
const ACADEMY_LINK = 'https://academy.givebutter.com/';
const OFFICE_HOURS_LINK = 'https://givebutter.com/office-hours';
const FUNDRAISING_GUIDE_LINK = `https://givebutter.com/blog/category/fundraising-ideas`;
const TEXT_TO_DONATE_GUIDE_LINK = `${HELP_CENTER_LINK}/articles/4044807-how-to-configure-text-to-donate`;
const AUCTIONS_LEARN_MORE_LINK = 'https://givebutter.com/auctions';
const SIGNUP_LINK = 'https://givebutter.com/signup';
const CAMPAIGN_HELP_CREATE_LINK = `${HELP_CENTER_LINK}/articles/125627-how-to-create-a-campaign-to-start-raising-funds`;
const CAMPAIGN_HELP_CREATE_TYPES_LINK = `${HELP_CENTER_LINK}/articles/125627-how-to-create-a-campaign-to-start-raising-funds#h_427b17b613`;
const CAMPAIGN_TYPE_LINK =
    'https://help.givebutter.com/en/articles/125627-how-to-choose-the-right-campaign-type-for-you';
const STICKER_FORM_LINK =
    'https://docs.google.com/forms/d/e/1FAIpQLSf30XHxFXvup25ZDhhMuaA7IEIGODuERXjt9RiMQboQfuxX5A/viewform?usp=pp_url&entry.1648073931=';
const IOS_MOBILE_APP_LINK = 'https://givebutter.com/app/ios-download';
const ANDROID_MOBILE_APP_LINK = 'https://givebutter.com/app/android-download';
const THESHAREWAY_LINK =
    'https://www.theshareway.com/?utm_source=gb&utm_medium=web&utm_campaign=auction_tooltip';
const WINSPIRE_LINK = `https://you.winspireme.com/travel-auction-items`;
const LUXGIVE_LINK = `https://luxgive.com/givebutter?utm_source=givebutter`;
const CHARIOT_LINK = 'https://givechariot.com/';
const CHARIOT_HELP_LINK = `${HELP_CENTER_LINK}/articles/6764835-how-to-use-givebutter-s-daf-donation-method-via-chariot`;
const NONPROFIT_VERIFICATION_LINK = `${HELP_CENTER_LINK}/articles/2755361-how-to-verify-your-nonprofit-and-the-benefits-of-doing-so`;
const NONPROFIT_VERIFICATION_EXAMPLE_LETTER_LINK =
    'https://downloads.intercomcdn.com/i/o/660463749/8384e652797aceb62c1fa792/CleanShot+2023-01-26+at+16.30.47%402x.png';
const DATA_HYGIENE_HELP_LINK = `${HELP_CENTER_LINK}/articles/9869247-how-to-validate-and-maintain-your-contact-data-with-data-hygiene`;

const ACCOUNT_MEMBER_ROLES_HELP = `${HELP_CENTER_LINK}/articles/2118934-how-to-manage-account-users`;

const WIDGETS_LIB_LINK = import.meta.env.VITE_DASHBOARD_WIDGETS_LIB;
const WIDGETS_DOCS_LINK = `${DOCS_LINK}/docs/widgets`;
const WIDGETS_GUIDE_LINK = `${HELP_CENTER_LINK}/collections/3611528-website-embeds`;
const CAMPAIGN_TYPES_LINK = `${HELP_CENTER_LINK}/articles/125627-givebutter-s-products-explained`;
const CAMPAIGN_CUSTOM_RECEIPTS_LINK = `${HELP_CENTER_LINK}/articles/2219216-custom-receipts`;
const CAMPAIGN_FEE_TYPE_LINK = `${HELP_CENTER_LINK}/articles/4117457-tips-fees-and-our-commitment-to-100-transparency`;
const CAMPAIGN_EXPERTS_LINK = 'https://givebutter.com/experts';
const BETA_ACCESS_GUIDE_LINK = `${HELP_CENTER_LINK}/articles/8213753-early-access-beta`;
const CAMPAIGN_LIVE_DISPLAY_LINK = `${HELP_CENTER_LINK}/articles/6684564-how-to-launch-and-configure-your-live-display`;
const CAMPAIGN_SLUG_LINK = `${HELP_CENTER_LINK}/articles/2267413-custom-urls`;
const CAMPAIGN_SEO_LINK = `${HELP_CENTER_LINK}/articles/3574469-a-beginner-s-guide-to-search-engine-optimization-seo-for-fundraising-campaigns`;
const CAMPAIGN_TEAM_FUNDRAISING_SETTINGS_LINK = `${HELP_CENTER_LINK}/articles/3586666-how-to-use-team-member-fundraising`;
const CAMPAIGN_TEAM_MULTITEAM_FUNDRAISING_SETTINGS_LINK = `${HELP_CENTER_LINK}/articles/1749223-how-to-use-multi-team-fundraising`;
const WITHDRAWALS_HELP_LINK = `${HELP_CENTER_LINK}/articles/1761146-how-do-withdrawals-work-do-i-have-to-reach-my-goal`;
const PAYMENT_METHODS_HELP_LINK = `${HELP_CENTER_LINK}/articles/1726573-available-payment-methods-through-givebutter`;
const RECURRING_PLANS_HELP_LINK = `${HELP_CENTER_LINK}/articles/3216251-how-to-enable-and-manage-recurring-plans`;
const DEDICATIONS_HELP_LINK = `${HELP_CENTER_LINK}/articles/3408139-how-to-enable-and-manage-dedications-in-honor-in-memory-of}`;
const REDUCE_SPAM_COMPLAINTS_HELP_LINK = `${HELP_CENTER_LINK}/articles/9016504-how-to-reduce-spam-complaints-for-outbound-emails`;
const PAYOUTS_HELP_LINK = `${HELP_CENTER_LINK}/articles/1761146-how-to-withdraw-funds`;
const QUICKBOOKS_HELP_LINK = `${HELP_CENTER_LINK}/articles/11403316-how-to-integrate-quickbooks-with-givebutter`;

// imports
const IMPORT_CONTACTS_LINK = `${HELP_CENTER_LINK}/articles/5497872-how-to-import-contacts`;
const IMPORT_CONTACT_ACTIVITIES_LINK = `${HELP_CENTER_LINK}/articles/5526927-how-to-add-and-import-contact-activities#h_2bab79791b`;
const IMPORT_TRANSACTIONS_LINK = `${HELP_CENTER_LINK}/articles/6934176-how-to-import-transactions`;
const IMPORT_PLANS_LINK = `${HELP_CENTER_LINK}/articles/5489025-how-to-migrate-recurring-plans`;
const IMPORT_TRANSACTIONS_TEMPLATE_LINK =
    'https://docs.google.com/spreadsheets/d/1ODr01y0_1sbk56ZtvhCE0lhoGo8zV985rxVimg4JcbE/edit?pli=1&gid=341059224#gid=341059224';

const FTC_CAN_SPAM_INFO_LINK =
    'https://www.ftc.gov/business-guidance/resources/can-spam-act-compliance-guide-business';
const PLATFORM_FEE_LINK =
    'https://help.givebutter.com/en/articles/4117457-tips-fees-and-our-commitment-to-100-transparency#h_727393a407';

const AUCTION_PACKAGES_LEARN_MORE_LINK = `${HELP_CENTER_LINK}/articles/9541127-how-to-add-sponsored-items-to-your-auction-with-givebutter-partners`;
const PLUS_MARKETING_LINK = 'https://givebutter.com/plus';
const PLUS_PRICING_LINK = 'https://givebutter.com/pricing';
const GIVEBUTTER_TOS_LINK = 'https://givebutter.com/terms';
const GIVEBUTTER_PRIVACY_POLICY_LINK = 'https://givebutter.com/privacy';
const GIVEBUTTER_CHANGELOG_LINK = 'https://community.givebutter.com/changelog';
const EMAIL_VERIFICATION_LINK = `${APP_URL}/email/verify`;

const CONNECT_WITH_STRIPE_LINK = `${HELP_CENTER_LINK}/articles/10401823-how-to-add-and-edit-your-payout-information-with-stripe-connect`;

// resources for recommended actions
const WITHDRAWALS_HOW_TO_LINK = `${HELP_CENTER_LINK}/articles/1761146-how-to-withdraw-funds`;
const MOBILE_APP_OVERVIEW_LINK = `${HELP_CENTER_LINK}/articles/6868930-how-to-use-the-givebutter-mobile-app`;
const CREATE_OUTBOUND_EMAIL_LINK = `${HELP_CENTER_LINK}/articles/6523588-how-to-create-an-outbound-email`;
const WHAT_IS_GIVEBUTTER_PLUS_LINK = `${HELP_CENTER_LINK}/articles/9756989-what-is-givebutter-plus`;
const WIDGETS_ON_YOUR_SITE_LINK = `${HELP_CENTER_LINK}/articles/6464859-how-to-use-givebutter-widgets-on-your-website`;
const BRANDING_LINK = `${HELP_CENTER_LINK}/articles/2219159-how-to-customize-your-account-settings-and-branding`;

const DOWNLOAD_MOBILE_GOOGLE_STORE =
    'https://play.google.com/store/apps/details?id=com.givebutter&hl=en_US';
const DOWNLOAD_MOBILE_IOS_STORE = 'https://apps.apple.com/us/app/givebutter/id1631051209';

export {
    BETA_ACCESS_GUIDE_LINK,
    CONTACT_US_LINK,
    CONTACT_SALES_LINK,
    DOCS_LINK,
    HELP_CENTER_LINK,
    WEBINARS_LINK,
    BUTTER_BLOG_LINK,
    FREEBIES_LINK,
    ROADMAP_LINK,
    ACADEMY_LINK,
    OFFICE_HOURS_LINK,
    FUNDRAISING_GUIDE_LINK,
    TEXT_TO_DONATE_GUIDE_LINK,
    AUCTIONS_LEARN_MORE_LINK,
    CAMPAIGN_TYPE_LINK,
    STICKER_FORM_LINK,
    IOS_MOBILE_APP_LINK,
    ANDROID_MOBILE_APP_LINK,
    SIGNUP_LINK,
    THESHAREWAY_LINK,
    WINSPIRE_LINK,
    LUXGIVE_LINK,
    CHARIOT_LINK,
    CHARIOT_HELP_LINK,
    NONPROFIT_VERIFICATION_LINK,
    ACCOUNT_MEMBER_ROLES_HELP,
    NONPROFIT_VERIFICATION_EXAMPLE_LETTER_LINK,
    WIDGETS_LIB_LINK,
    WIDGETS_DOCS_LINK,
    WIDGETS_GUIDE_LINK,
    CAMPAIGN_TYPES_LINK,
    CAMPAIGN_HELP_CREATE_LINK,
    CAMPAIGN_HELP_CREATE_TYPES_LINK,
    CAMPAIGN_CUSTOM_RECEIPTS_LINK,
    CAMPAIGN_FEE_TYPE_LINK,
    CAMPAIGN_EXPERTS_LINK,
    CAMPAIGN_LIVE_DISPLAY_LINK,
    CAMPAIGN_SLUG_LINK,
    CAMPAIGN_SEO_LINK,
    CAMPAIGN_TEAM_FUNDRAISING_SETTINGS_LINK,
    CAMPAIGN_TEAM_MULTITEAM_FUNDRAISING_SETTINGS_LINK,
    WITHDRAWALS_HELP_LINK,
    FTC_CAN_SPAM_INFO_LINK,
    PAYMENT_METHODS_HELP_LINK,
    RECURRING_PLANS_HELP_LINK,
    DEDICATIONS_HELP_LINK,
    PLATFORM_FEE_LINK,
    AUCTION_PACKAGES_LEARN_MORE_LINK,
    IMPORT_CONTACTS_LINK,
    IMPORT_CONTACT_ACTIVITIES_LINK,
    IMPORT_TRANSACTIONS_LINK,
    IMPORT_PLANS_LINK,
    IMPORT_TRANSACTIONS_TEMPLATE_LINK,
    PLUS_MARKETING_LINK,
    PLUS_PRICING_LINK,
    GIVEBUTTER_TOS_LINK,
    GIVEBUTTER_PRIVACY_POLICY_LINK,
    GIVEBUTTER_CHANGELOG_LINK,
    DATA_HYGIENE_HELP_LINK,
    REDUCE_SPAM_COMPLAINTS_HELP_LINK,
    WITHDRAWALS_HOW_TO_LINK,
    MOBILE_APP_OVERVIEW_LINK,
    CREATE_OUTBOUND_EMAIL_LINK,
    WHAT_IS_GIVEBUTTER_PLUS_LINK,
    WIDGETS_ON_YOUR_SITE_LINK,
    BRANDING_LINK,
    DOWNLOAD_MOBILE_GOOGLE_STORE,
    DOWNLOAD_MOBILE_IOS_STORE,
    CONNECT_WITH_STRIPE_LINK,
    PAYOUTS_HELP_LINK,
    EMAIL_VERIFICATION_LINK,
    QUICKBOOKS_HELP_LINK,
};
